<template>
    <div class="gold-head">
        <div class="gold-logo ta-c"><img class="h100" src="../assets/css-img/gold-logo.png"></div>
        <div class="gold-sub-title ta-c"><span>—— </span><span>{{goldStates.subTitle}}</span><span> ——</span></div>
        <div class="gold-amount ta-c"><span class="money-icon"></span>{{goldAmount}}</div>
        <div class="gold-slogen"><h5 class=ta-c>{{goldStates.slogenText}}</h5><h6 class=ta-c>
            {{goldStates.slogenSubText}}</h6></div>
        <a class="gold-btn block" :href="goldStates.btnHref" clstag="pageclick|keycount|jieqian|jintiao|url">{{goldStates.btnText}}</a>
    </div>
</template>

<script type="text/javascript">
    import toThousand from "../tools/toThousands";

    var getGoldStates = function (goldData) {
        if (goldData.ajaxError) { //接口异常
            return {
                subTitle: "最高可借",
                slogenText: "啊哦，系统开小差了~",
                slogenSubText: "请稍后再试",
                btnText: "点击重试",
                btnHref: window.location.href
            }
        }
        if (goldData.isLogin == false) { //未登录
            _hmt.push(['_trackEvent', 'jieqian', 'ajax', 'show']);
            return {
                subTitle: "最高可借",
                slogenText: "现金借款 · 随借随还",
                slogenSubText: "支持借款到信用卡，方便还信用卡",
                btnText: "立即登录",
                btnHref: "//passport.m.jd.com/user/login.action?v=1&returnurl=" + encodeURIComponent(window.location.href)
            }
        }
        if (!goldData.isOpenJt) {     //没开通金条的情况
            _hmt.push(['_trackEvent', 'jieqian', 'ajax', 'show']);
            return {
                subTitle: "最高可借",
                slogenText: "现金借款 · 随借随还",
                slogenSubText: "支持借款到信用卡，方便还信用卡",
                btnText: "开通京东金条借钱",
                btnHref: "https://ms.jr.jd.com/jrpmobile/btbullion/bullion/jinTiaoIndex?sysCode=s2&sourceLink=c2"
            }
        }
        if (goldData.isOpenJt) {  //开通了金条没借钱
            return {
                subTitle: "当前可借金额",
                slogenText: "日利率低至 0.025%",
                slogenSubText: "1000元借1天，利息低至0.25元",
                btnText: "立即借款",
                btnHref: "https://ms.jr.jd.com/jrpmobile/btbullion/bullion/jinTiaoIndex?sysCode=s2&sourceLink=c2"
            }
        }
    }
    export default {
        name: 'gold_head',
        props: {
            goldData: {
                type: Object,
                default: function () {
                    return {
                        isOpenJt: false,
                        isLogin: false,
                        availableAssets: 300000
                    }
                }
            }
        },
        data: function () {
            return {}
        },
        computed: {
            goldAmount: function () {
                var goldNum = 0;
                if (this.goldData.isLogin && this.goldData.isOpenJt) {
                    goldNum = this.goldData.availableAssets;
                } else {
                    goldNum = 300000;
                }
                return toThousand(goldNum)
            },
            goldStates: function () {
                var result = getGoldStates(this.goldData);
                return result;
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss">
    .gold-head { width: 3.75rem; height: 3.75rem; background: url(../assets/css-img/head-bg.png) no-repeat; background-size: 100% auto; position: relative; color: #fff; margin-bottom: 0.3rem; }
    .gold-logo { height: 0.45rem; padding-top: 0.5rem; }
    .gold-sub-title { color: #ffeac9; font-size: 0.14rem; width: 100%; }
    .money-icon { width: 0.37rem; height: 0.45rem; background: url(../assets/css-img/money-icon.png) no-repeat center center; background-size: contain; display: inline-block; position: relative; vertical-align: bottom; top: 0.08rem; }
    .gold-amount { font-size: 0.65rem; line-height: 1; margin-top: 0.08rem; font-family: "DIN-Bold"; text-shadow: 0 7px 10px rgba(63, 39, 0, .2); position: relative; }
    .gold-slogen { line-height: 1;
        h5 { font-size: 0.22rem; margin-top: 0.45rem; }
        h6 { font-size: 0.14rem; margin-top: 0.15rem; }
        }
    .gold-btn { width: 2.53rem; height: 0.74rem; background: url(../assets/css-img/gold-btn.png) no-repeat; background-size: cover; position: absolute; bottom: -0.2rem; left: 50%; margin-left: -1.26rem; font-size: 0.18rem; text-align: center; line-height: 0.55rem; text-shadow: 0 6px 8px rgba(107, 15, 0, .4); color: #fff; }
</style>



// WEBPACK FOOTER //
// Gold-head.vue?37a0e186